<template>
  <div :class="clsx('feature-list', `feature-list--${listType}`, { 'animations-disabled': !animationEnabled })">
    <h4 class="feature-list__title">{{ title }}</h4>
    <ul class="feature-list__items">
      <li v-for="(item, index) in items" :key="item.text" :class="clsx('feature-list__item', `feature-list__item--${index}`)">
        <component
          v-if="typeof item.icon === 'string' && imageComponents[item.icon]"
          :is="imageComponents[item.icon]"
          class="feature-list__icon"
        />
        <span v-else class="feature-list__icon">{{ item.icon }}</span>
        <span v-html="item.text"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import clsx from 'clsx';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    listType: {
      type: String,
      default: 'simple',
    },
    items: {
      type: Array,
      default: () => [],
    },
    imageComponents: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: { clsx },
};
</script>

<style scoped lang="scss">
.feature-list {
  background-color: #FFFFFF;
  border-radius: 32px;
  padding: 32px;

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 22px;
    font-weight: 400;
    text-align: center;
    border-radius: 16px;
    padding: 14px;
    margin-bottom: 16px;
  }

  &--simple {
    transform: translateX(-150px) scale(0);
    opacity: 0;
    height: 120px;
    overflow: hidden;
    animation: simple-feature-list-slide 0.5s linear forwards, feature-list-expand 2s linear forwards;
    animation-delay: 0s, 0.5s;
    animation-play-state: paused;

    .feature-list__title {
      background-color: #EBF2FF;
    }

    .feature-list__item {
      transform: translateX(-100%);
      opacity: 0;
      animation: simple-feature-item-slide 0.25s linear forwards;
      animation-play-state: paused;

      &--0 {
        animation-delay: 0.65s;
      }

      &--1 {
        animation-delay: 0.925s;
      }

      &--2 {
        animation-delay: 1.2s;
      }

      &--3 {
        animation-delay: 1.4525s;
      }

      &--4 {
        animation-delay: 1.8s;
      }

      &--5 {
        animation-delay: 2.1s;
      }
    }
  }

  &--fancy {
    box-shadow: -27px 73px 59.34px 0px #495A9514, 0px 16.23px 32.1px 0px #7490BC1C;
    transform: translateX(150px) scale(0);
    opacity: 0;
    height: 120px;
    animation: fancy-feature-list-slide 0.5s linear forwards, feature-list-expand 2s linear forwards;
    animation-delay: 2.5s, 3s;
    animation-play-state: paused;
    overflow: hidden;

    .feature-list__title {
      background-color: #EB883B;
      border: 1px solid #FCFDFF;
      color: #FCFDFF;
    }

    .feature-list__item {
      transform: translateX(100%);
      opacity: 0;
      animation: fancy-feature-item-slide 0.25s linear forwards;
      animation-delay: 2.5s;
      animation-play-state: paused;

      &--0 {
        animation-delay: 3.15s;
      }

      &--1 {
        animation-delay: 3.425s;
      }

      &--2 {
        animation-delay: 3.75s;
      }

      &--3 {
        animation-delay: 4.025s;
      }

      &--4 {
        animation-delay: 4.35s;
      }

      &--5 {
        animation-delay: 4.55s;
      }
    }
  }

  &__item {
    display: flex;
    align-items: center;
    max-width: 430px;
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #09090B;
    background-color: #F9FBFF;
    border-radius: 16px;
    padding: 12px 24px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    font-size: 33px;
    margin-right: 12px;
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .feature-list {
    &--simple {
      transform: translateX(0);
      height: 100%;
      opacity: 1;

      .feature-list__item {
        transform: translateX(0);
        opacity: 1;
      }
    }

    &--fancy {
      transform: translateX(0);
      height: 100%;
      opacity: 1;

      .feature-list__item {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
}

@keyframes simple-feature-list-slide {
  from {
    transform: translateX(-150px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fancy-feature-list-slide {
  from {
    transform: translateX(150px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes feature-list-expand {
  from {
    height: 120px;
  }
  to {
    height: 100%;
  }
}

@keyframes simple-feature-item-slide {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fancy-feature-item-slide {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
